const favoritesInitialState = {
  value: [],
};

export default favoritesInitialState;